import React from 'react'

import UspBadge from '../usp-badge'
import { UspIcon } from '~/assets/icons'
import { useInBucket } from '~/hooks/use-in-bucket'

import styles from './hero-line.module.css'

const HeroLine = () => {
  const isBlackFriday = useInBucket('experiment-black-friday-2023', 'variant')

  if (!isBlackFriday) return null

  return (
    <div className={styles.line}>
      <span className={styles.text}>Look out for</span>

      <UspBadge
        className={styles.badge}
        text='Black Friday'
        icon={<UspIcon promotionType='black-friday' />}
        variant='black-primary'
      />

      <span className={styles.text}>in your results</span>
    </div>
  )
}

export default HeroLine
